import { Dropdown, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ApplicationNotesActionMenu.css";

import { ThreeDots } from "../../../../customComponent/ThreeDots";
import { useDispatch, useSelector } from "react-redux";
import { selectIsFetching } from "../../../../../store/selector";
import { ApiNames } from "../../../../../api/api";
import ACTIONS from "../../../../../store/action";
import { ReactComponent as AlertIcon } from "../../../../../assets/svg/alert-icon-popup.svg";
import { StyledMenuItemButton, StyledThreeDotsButton } from "../../../../sharedComponents/EditNotesUI";

const { confirm } = Modal;

export const ApplicationNotesActionMenu = ({ note, isVisible, onMenuHoverChange, onEditNote, setHoveredNoteId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);

  const isFetchingDeleteNote = useSelector(selectIsFetching([ApiNames.DeleteEnrollmentNote]));

  const deleteEnrollmentNoteAct = (noteId) => dispatch(ACTIONS.deleteEnrollmentNoteAction(noteId));

  const handleDeleteNote = () => {
    confirm({
      zIndex: 1100,
      centered: true,
      icon: <AlertIcon />,
      title: t("patientRSActions.notes.delete_note_popup_title"),
      content: t("patientRSActions.notes.delete_note_popup_content"),
      cancelText: t("patientRSActions.notes.delete_note"),
      okText: t("patientRSActions.notes.keep_note"),
      okCancelProps: {
        loading: isFetchingDeleteNote
      },
      onOk: () => {
        onMenuHoverChange(false);
        setHoveredNoteId(null);
      },
      onCancel: async () => {
        await deleteEnrollmentNoteAct(note.id);
      },
      okButtonProps: {
        id: "keep_note_button"
      },
      cancelButtonProps: {
        id: "delete_note_button"
      }
    });
  };

  const handleEditNote = () => {
    onEditNote?.(note);
    setIsOpen(false);
  };

  const dropdownItems = [
    {
      key: "edit",
      label: (
        <StyledMenuItemButton onClick={handleEditNote} type="text" id="note_edit_option">
          {t("patientApplications.track_tab.edit_note")}
        </StyledMenuItemButton>
      )
    },
    {
      key: "delete",
      label: (
        <StyledMenuItemButton onClick={handleDeleteNote} type="text" id="note_delete_option">
          {t("patientApplications.track_tab.delete_note")}
        </StyledMenuItemButton>
      )
    }
  ];

  useEffect(() => {
    if (!isVisible && !isMenuHovered) {
      setIsOpen(false);
    }
  }, [isVisible, isMenuHovered]);

  const handleMenuHover = (isHovered) => {
    setIsMenuHovered(isHovered);
    onMenuHoverChange?.(isHovered);
  };

  const handleOpenChange = (visible) => {
    setIsOpen(visible);
  };

  const dropdownRender = (menu) => (
    <div onMouseEnter={() => handleMenuHover(true)} onMouseLeave={() => handleMenuHover(false)}>
      {menu}
    </div>
  );

  return (
    <Dropdown
      menu={{
        items: dropdownItems
      }}
      trigger={["click"]}
      placement="bottomRight"
      open={isVisible && isOpen}
      onOpenChange={handleOpenChange}
      dropdownRender={dropdownRender}
      align={{
        offset: [0, 4],
        overflow: { adjustY: false }
      }}
      onMouseEnter={() => setHoveredNoteId(note.id)}
      overlayClassName="custom-notes-action-menu"
    >
      <StyledThreeDotsButton type="text" id="note_action_menu">
        <ThreeDots />
      </StyledThreeDotsButton>
    </Dropdown>
  );
};
